var render = function render(){var _vm=this,_c=_vm._self._c;return (Boolean(_vm.selected))?_c('vs-col',{staticClass:"reset-alert-height"},[_c('vs-alert',{attrs:{"active":Boolean(_vm.selected),"color":"dark"}},[_c('h3',[_vm._v(_vm._s(_vm.selected.NOMECOMERCIAL))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }